if (!customElements.get('ooo-purchase-band')) {
  customElements.define('ooo-purchase-band', class extends HTMLElement {
    connectedCallback() {
      const productData = this.querySelector('[data-ooo-product-json]');
      this.product = productData ? JSON.parse(productData.textContent) : null;
      this.form = this.querySelector('form');
      if (!this.product || !this.form) return;

      this.variantInput = this.querySelector('[data-ooo-variant-input]');
      this.quantityInput = this.querySelector('[data-ooo-quantity-input]');
      this.cartButton = this.querySelector('[data-ooo-cart-button]');
      this.priceValue = this.querySelector('[data-ooo-price]');
      this.comparePrice = this.querySelector('[data-ooo-compare-price]');
      this.selectionText = this.querySelector('[data-ooo-selection-text]');
      this.status = this.querySelector('[data-ooo-status]');
      this.currentVariant = this.variantById(this.dataset.initialVariantId);
      this.loading = false;

      this.onMediaSelection = (event) => {
        if (Number(event.detail?.productId) !== Number(this.product.id)) return;
        this.selection = event.detail;
        this.updateVariant(this.variantById(event.detail.variantId));
        this.updateSelection();
      };
      this.onVariantChange = (event) => {
        if (Number(event.detail?.product?.id) !== Number(this.product.id)) return;
        this.updateVariant(this.variantById(event.detail.variant?.id));
      };
      this.onSubmit = (event) => this.submit(event);
      this.onQuantityClick = (event) => {
        const direction = event.target.closest('[data-ooo-quantity-plus]') ? 1 :
          event.target.closest('[data-ooo-quantity-minus]') ? -1 : 0;
        if (!direction) return;
        this.quantityInput.value = Math.max(1, (parseInt(this.quantityInput.value, 10) || 1) + direction);
      };

      document.addEventListener('ooo:product-media-selection:change', this.onMediaSelection);
      document.addEventListener('theme:variant:change', this.onVariantChange);
      this.form.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onQuantityClick);

      const savedSelection = window.oooMediaSelectionByProduct?.[this.product.id];
      if (savedSelection) this.onMediaSelection({ detail: savedSelection });
      else this.updateVariant(this.currentVariant);
    }

    disconnectedCallback() {
      document.removeEventListener('ooo:product-media-selection:change', this.onMediaSelection);
      document.removeEventListener('theme:variant:change', this.onVariantChange);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onQuantityClick);
    }

    variantById(id) {
      return this.product.variants.find((variant) => Number(variant.id) === Number(id)) || null;
    }

    updateVariant(variant) {
      if (!variant) return;
      this.currentVariant = variant;
      this.variantInput.value = variant.id;
      if (variant.title && !variant.title.includes('Default')) {
        this.selectionText.textContent = variant.title;
      }
      if (typeof formatMoney === 'function') {
        this.priceValue.textContent = formatMoney(variant.price, window.theme?.moneyFormat);
        if (variant.compare_at_price > variant.price) {
          this.comparePrice.textContent = formatMoney(variant.compare_at_price, window.theme?.moneyFormat);
          this.comparePrice.hidden = false;
        } else {
          this.comparePrice.hidden = true;
        }
      }
      this.cartButton.disabled = !variant.available || this.loading;
      this.cartButton.textContent = variant.available ? this.dataset.cartLabel : this.dataset.soldOutLabel;
    }

    updateSelection() {
      const { leather, finish } = this.selection;
      const gallery = Array.from(document.querySelectorAll('[data-ooo-gallery-pickers]'))
        .find((element) => Number(element.dataset.productId) === Number(this.product.id));
      const leatherButton = Array.from(gallery?.querySelectorAll('[data-ooo-leather-name]') || [])
        .find((element) => element.dataset.oooLeatherName === leather);
      const finishButton = Array.from(gallery?.querySelectorAll('[data-ooo-finish-name]') || [])
        .find((element) => element.dataset.oooFinishName === finish);
      if (leatherButton && finish) this.selectionText.textContent = `${leather} with ${finish} base`;
      else if (this.currentVariant?.title && !this.currentVariant.title.includes('Default')) {
        this.selectionText.textContent = this.currentVariant.title;
      }
      this.updateSwatch('[data-ooo-leather-swatch]', leatherButton);
      this.updateSwatch('[data-ooo-finish-swatch]', finishButton);

    }

    updateSwatch(selector, button) {
      const swatch = this.querySelector(selector);
      const source = button?.querySelector('.ooo-media-filter__swatch');
      const background = source?.style.getPropertyValue('--ooo-media-filter-swatch-background');
      swatch.style.background = background || '';
      swatch.hidden = !background;
    }

    showStatus(message) {
      this.status.textContent = message || '';
      this.status.hidden = !message;
    }

    async submit(event) {
      event.preventDefault();
      if (this.loading || !this.currentVariant?.available) return;
      this.loading = true;
      this.cartButton.disabled = true;
      this.showStatus('Adding to cart…');
      const formData = new FormData(this.form);
      formData.set('id', String(this.currentVariant.id));
      formData.append('sections', 'cart-items,cart-footer,cart-item-count');
      formData.append('sections_url', window.location.pathname);

      try {
        const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add this selection to the cart.');
        }
        this.showStatus('Added to cart.');
        document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
          bubbles: true,
          detail: { response: data, sourceId: this.form.id }
        }));
      } catch (error) {
        this.showStatus(error.message || 'Could not add this selection to the cart.');
      } finally {
        this.loading = false;
        this.cartButton.disabled = !this.currentVariant?.available;
      }
    }
  });
}
